/* RESPONSIBLE TEAM: team-standalone */

import { tracked } from '@glimmer/tracking';
import { TicketField } from 'embercom/objects/standalone/data-fields/common';

const BUILT_IN_CASE_FIELD_ATTRIBUTES = ['id', 'subject', 'description', 'origin'];

export class SalesforceCaseFields {
  @tracked caseFields: TicketField[] = [];
  @tracked cvdasForRequiredSalesforceCaseFields: {
    intercom_cvda: { id: string };
    salesforce_field_id: string;
  }[] = [];

  constructor(inputs: {
    caseFields: TicketField[];
    cvdasForRequiredSalesforceCaseFields: {
      intercom_cvda: { id: string };
      salesforce_field_id: string;
    }[];
  }) {
    this.cvdasForRequiredSalesforceCaseFields = inputs.cvdasForRequiredSalesforceCaseFields || [];
    this.caseFields = this.builtInCaseFields.concat(inputs.caseFields);
  }

  get builtInCaseFields(): TicketField[] {
    return BUILT_IN_CASE_FIELD_ATTRIBUTES.map((field) => {
      return new TicketField({
        id: field,
        name: this.titleCase(field),
        required: true,
        type: 'string',
        intercom_cvda: this.cvdasForRequiredSalesforceCaseFields.find(
          (cvda) => cvda.salesforce_field_id.toLowerCase() === field.toLowerCase(),
        )?.intercom_cvda,
        built_in: true,
      });
    });
  }

  titleCase(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
